import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <section className="text-center py-16">
      <h1 className="mb-2">404</h1>
      <p className="text-muted mb-6">That page isn&apos;t wired up yet.</p>
      <Link to="/" className="text-brand-dark underline">
        Back to home
      </Link>
    </section>
  );
}
